/* eslint-disable */

export enum SubscriptionChannel {
  NOTIFICATIONS = 0,
  UNRECOGNIZED = -1,
}

export interface SubscriptionRequest {
  channel: SubscriptionChannel;
  upn: string;
}

export interface SubscriptionEvent {
  /** JSON */
  data: string;
  id?: string | undefined;
  type?: string | undefined;
  retry?: number | undefined;
}

export interface SubscriptionNotifyRequest {
  channel: SubscriptionChannel;
  upn: string;
  messageId: string;
}
